import { promise } from '../../../helpers';
import { updateFacilitatorsGroupsItem } from './index';

const updateFacilitatorsGroupsItems = props => {
    const { where } = props;

    if (where) {
        return updateFacilitatorsGroupsItem(props);
    }

    return promise();
};

export default updateFacilitatorsGroupsItems;
